import { useQuery } from "@tanstack/react-query";
import { getProfile } from "entities/viewer";
import { useEffect } from "react";

export const useWatchGlobalCurrency = () => {
  const { data } = useQuery({
    queryKey: ["profile"],
    queryFn: () => getProfile(),
  });

  useEffect(() => {
    if (data?.settings?.text_attributes) {
      localStorage.setItem(
        "NEGATIVE_PREFIX",
        data.settings.text_attributes.NEGATIVE_PREFIX,
      );
      localStorage.setItem(
        "NEGATIVE_SUFFIX",
        data.settings.text_attributes.NEGATIVE_SUFFIX,
      );
      localStorage.setItem(
        "POSITIVE_PREFIX",
        data.settings.text_attributes.POSITIVE_PREFIX,
      );
      localStorage.setItem(
        "POSITIVE_SUFFIX",
        data.settings.text_attributes.POSITIVE_SUFFIX,
      );
    } else {
      localStorage.setItem("NEGATIVE_PREFIX", "");
      localStorage.setItem("NEGATIVE_SUFFIX", "");
      localStorage.setItem("POSITIVE_PREFIX", "");
      localStorage.setItem("POSITIVE_SUFFIX", "");
    }
  }, [data]);
};
